export function normalizeLanguageBase(code: string): string {
  return code.split("-")[0].toLowerCase();
}

export function getEnvSupportedLanguageCodes(): Set<string> | null {
  const raw = import.meta.env.VITE_APP_SUPPORTED_LANGUAGES?.trim();
  if (!raw) {
    return null;
  }

  const codes = raw
    .split(",")
    .map((code) => code.trim().toLowerCase())
    .filter(Boolean);

  return codes.length > 0 ? new Set(codes) : null;
}

export function isLanguageCodeAllowed(
  code: string,
  allowed = getEnvSupportedLanguageCodes(),
): boolean {
  if (!allowed) {
    return true;
  }

  return allowed.has(normalizeLanguageBase(code));
}

export function filterAllowedLanguages(languages: string[]): string[] {
  const allowed = getEnvSupportedLanguageCodes();
  if (!allowed) {
    return languages;
  }

  return languages.filter((language) => isLanguageCodeAllowed(language, allowed));
}
